import React from 'react'
import './PrivacyPolicy.scss'

const PrivacyPolicy = () => {
    return (
        <div className='privacy-policy'>

            <h1>Polityka prywatności serwisu clinknest.com</h1>

            <h2>1. Informacje ogólne</h2>
            <p>Administratorem danych osobowych użytkowników serwisu <strong>clinknest.com</strong> jest:</p>
            <p> <strong>Cinknest</strong><br />
                ul. Przykładowa 123,<br />
                00-001 Warszawa<br />
                NIP: 123-45-67-890
            </p>
            <p>(dalej: „Administrator”).</p>
            <p>Kontakt z Administratorem jest możliwy pod adresem e-mail: <strong>kontakt@clinknest.com</strong>.</p>
            <p>Administrator przetwarza dane osobowe zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO).</p>

            <h2>2. Zakres i cel przetwarzania danych</h2>
            <p>Administrator może przetwarzać następujące dane osobowe użytkowników:</p>
            <ul>
                <li>imię i nazwisko,</li>
                <li>adres e-mail,</li>
                <li>numer telefonu,</li>
                <li>dane przekazywane dobrowolnie w formularzach kontaktowych,</li>
                <li>dane techniczne związane z korzystaniem z serwisu (adres IP, pliki cookies, identyfikatory urządzeń).</li>
            </ul>
            <p>Cele przetwarzania:</p>
            <ul>
                <li>udzielanie odpowiedzi na zapytania przesłane przez użytkowników,</li>
                <li>realizacja usług świadczonych drogą elektroniczną,</li>
                <li>przesyłanie informacji marketingowych (jeśli użytkownik wyrazi na to zgodę),</li>
                <li>zapewnienie bezpieczeństwa serwisu i poprawa jego funkcjonalności,</li>
                <li>wypełnienie obowiązków prawnych ciążących na Administratorze.</li>
            </ul>

            <h2>3. Podstawy prawne przetwarzania</h2>
            <p>Administrator przetwarza dane osobowe na podstawie:</p>
            <ul>
                <li>art. 6 ust. 1 lit. a RODO – zgoda osoby,</li>
                <li>art. 6 ust. 1 lit. b RODO – konieczność wykonania umowy,</li>
                <li>art. 6 ust. 1 lit. c RODO – obowiązki prawne Administratora,</li>
                <li>art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes Administratora (np. dochodzenie roszczeń, analiza statystyk).</li>
            </ul>

            <h2>4. Odbiorcy danych</h2>
            <p>Dane osobowe mogą być przekazywane:</p>
            <ul>
                <li>podmiotom świadczącym usługi hostingowe i IT na rzecz Administratora,</li>
                <li>firmom obsługującym płatności (jeżeli dotyczy),</li>
                <li>kancelariom prawnym i doradcom, gdy będzie to konieczne do ochrony praw Administratora,</li>
                <li>organom publicznym, jeżeli taki obowiązek wynika z przepisów prawa.</li>
            </ul>

            <h2>5. Przechowywanie danych</h2>
            <p>Dane osobowe będą przechowywane:</p>
            <ul>
                <li>przez okres niezbędny do realizacji celu, w jakim zostały zebrane,</li>
                <li>do czasu cofnięcia zgody (jeśli podstawą przetwarzania była zgoda),</li>
                <li>do czasu przedawnienia ewentualnych roszczeń.</li>
            </ul>

            <h2>6. Prawa użytkowników</h2>
            <p>Użytkownik ma prawo do:</p>
            <ul>
                <li>dostępu do swoich danych,</li>
                <li>sprostowania danych,</li>
                <li>usunięcia danych („prawo do bycia zapomnianym”),</li>
                <li>ograniczenia przetwarzania,</li>
                <li>przenoszenia danych,</li>
                <li>sprzeciwu wobec przetwarzania,</li>
                <li>cofnięcia zgody w dowolnym momencie.</li>
            </ul>
            <p>Aby skorzystać z powyższych praw, należy skontaktować się z Administratorem na adres e-mail: <strong>kontakt@clinknest.com</strong>.</p>
            <p>Użytkownik ma również prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (PUODO).</p>

            <h2>7. Pliki cookies</h2>
            <p>1. Serwis korzysta z plików cookies w celu:</p>
            <ul>
                <li>zapewnienia prawidłowego działania strony,</li>
                <li>tworzenia statystyk,</li>
                <li>prowadzenia działań marketingowych (np. remarketingu).</li>
            </ul>
            <p>2. Użytkownik może w każdej chwili zmienić ustawienia plików cookies w swojej przeglądarce.</p>

            <h2>8. Postanowienia końcowe</h2>
            <ul>
                <li>Administrator zastrzega sobie prawo do wprowadzania zmian w Polityce prywatności.</li>
                <li>Aktualna wersja Polityki prywatności jest zawsze dostępna w serwisie <strong>clinknest.com</strong>.</li>
            </ul>

        </div>
    )
}

export default PrivacyPolicy